// Auto-generated TypeScript enum from PHP enum

export type PolicyScope = '256' | '0' | '128' | '32' | '1' | '64' | '2' | '4' | '8' | '16' | '512';

export const PolicyScope = {
  Aggregate: '256' as const,
  All: '0' as const,
  Count: '128' as const,
  Destroy: '32' as const,
  Index: '1' as const,
  Restore: '64' as const,
  Show: '2' as const,
  Store: '4' as const,
  StoreMany: '8' as const,
  Update: '16' as const,
  Validate: '512' as const,
} as const;

export const PolicyScopeUtils = {
  values: Object.values(PolicyScope),
  keys: Object.keys(PolicyScope) as Array<keyof typeof PolicyScope>,
  entries: Object.entries(PolicyScope) as Array<[keyof typeof PolicyScope, PolicyScope]>,
  isValid: (value: any): value is PolicyScope => Object.values(PolicyScope).includes(value),
  fromKey: (key: keyof typeof PolicyScope): PolicyScope => PolicyScope[key],
};

